import { AuthService } from "services/auth";
import { WorkspaceEngine } from "services/engines/engine.types";

import { FIREBOLT_UI_USER_ENGINE_QUERY_LABEL } from "pages/DevelopWorkspace/services/constants";
import { buildEngineUrl } from "pages/DevelopWorkspace/services/helpers/buildEngineUrl";
import { FetchOptions } from "pages/DevelopWorkspace/services/types";

export const getHistoryQuery = async (
  engine: WorkspaceEngine,
  queryLabel: string,
  serverQueryId: string | undefined,
  fetchOptions: FetchOptions,
  authService: AuthService
) => {
  const token = await authService.getToken();
  if (!token) {
    throw new Error("Failed to fetch query ID: token is not available");
  }

  const { headers, abortController } = fetchOptions;
  const engineURL = new URL(`https://${engine.url}`);
  const url = buildEngineUrl(engineURL, {
    query_label: FIREBOLT_UI_USER_ENGINE_QUERY_LABEL,
    auto_start_stop_control: "ignore",
  });

  const filterByQueryId = serverQueryId
    ? ` AND query_id = '${serverQueryId}' `
    : "";
  const response = await fetch(url, {
    signal: abortController.signal,
    method: "POST",
    headers: {
      ...headers,
      Authorization: `Bearer ${token}`,
    },
    body: `select qh.*,
                  ROW_NUMBER() OVER (PARTITION BY query_id ORDER BY CASE 
WHEN qh.status = 'STARTED_EXECUTION' THEN 0
ELSE 1 END DESC) AS rn from information_schema.engine_query_history qh where query_label = '${queryLabel}'${filterByQueryId}
order by start_time desc limit 1`,
  });

  if (response.ok) {
    const json = await response.json();

    const res = json.data[0];

    if (!res) {
      return null;
    }

    const query = {
      status: res.status,
      queryLabel: res.query_label,
      queryId: res.query_id,
      durationUsec: res.e2e_duration_us,
      scannedRows: res.scanned_rows,
      scannedBytes: res.scanned_bytes,
      scannedBytesCache: res.scanned_cache_bytes,
      scannedBytesStorage: res.scanned_storage_bytes,
      error: res.error_message,
    };

    return query;
  }
  throw new Error();
};
